import React from "react";
import { Trans, useTranslation } from "react-i18next";
import useSocketHandlers from "../Components/useSocketHandlers";

const Legal = () => {
  const { t } = useTranslation();
  const list1 = t("legalstuff.privacy.list1", { returnObjects: true });
  const list2 = t("legalstuff.privacy.list2", { returnObjects: true });
  const list_rights = t("legalstuff.privacy.list_rights", { returnObjects: true });
  const list_usa = t("legalstuff.privacy.list_usa", { returnObjects: true });


  return (
    <div className="content-box contact">
      <div className="legalbox">
        <h2 className="page_title">{t("legalstuff.title")}</h2>
        <div className="privacy formatted">
          <p>{t("legalstuff.subtitle1")}</p>
          <p>{t("legalstuff.subtitle2")}</p>
          <h3>{t("legalstuff.title2")}</h3>
          <h4>{t("legalstuff.website")}</h4>
          <p>{t("legalstuff.privacy.paragraph1")}</p>
          <ul>
            {list1.map((p, i) => (<li key={i}>{p}</li>))}
          </ul>
          <p>{t("legalstuff.privacy.paragraph2")}</p>
          <ul>
            {list2.map((p, i) => (<li key={i}>{p}</li>))}
          </ul>
          <h4>{t("legalstuff.privacy.title_email")}</h4>
          <p>{t("legalstuff.privacy.paragraph_email")}</p>
          <h4>{t("legalstuff.privacy.title_recipients")}</h4>
          <p>{t("legalstuff.privacy.paragraph_recipients")}</p>
          <p>{t("legalstuff.privacy.paragraph_exception")}</p>
          <h3 className="margin_top_30px">{t("legalstuff.privacy.title_eu")}</h3>
          <p>{t("legalstuff.privacy.paragraph_eu1")}</p>
          <p>{t("legalstuff.privacy.paragraph_eu2")}</p>
          <p>{t("legalstuff.privacy.title_rights")}</p>
          <ul>
            {list_rights.map((p, i) => (<li key={i}>{p}</li>))}
          </ul>
          <h3 className="margin_top_30px">{t("legalstuff.privacy.title_usa")}</h3>
          <p>{t("legalstuff.privacy.paragraph_usa1")}</p>
          <p>{t("legalstuff.privacy.paragraph_usa2")}</p>
          <p>{t("legalstuff.privacy.paragraph_usa3")}</p>
          <ul>
            {list_usa.map((p, i) => (<li key={i}>{p}</li>))}
          </ul>
          <h3 className="margin_top_30px">{t("legalstuff.privacy.title_other")}</h3>
          <p>{t("legalstuff.privacy.paragraph_other")}</p>
        </div>
      </div>
    </div>
  );
};

export default Legal;
